import React, { useEffect } from 'react';


const EditProperty = () => {
    useEffect(() => {
        // Initialize intl-tel-input when the component mounts
        const input = document.querySelector("#mobilepropertyedit");
        const iti = window.intlTelInput(input, {
            preferredCountries: ["us", "gb", "in", "au"],  // Customize preferred countries
            utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@17.0.8/build/js/utils.js"  // For better validation and formatting
        });

        // Cleanup the intl-tel-input when the component unmounts
        return () => {
            if (iti) {
                iti.destroy();
            }
        };
    }, []);

    return (
        <div>
            {/* Modal */}
            <div className="modal fade" id="EditpropertyModal" tabindex="-1" aria-labelledby="EditpropertyModal" aria-hidden="true">
                <div className="modal-dialog modal-xl">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title font-bold" id="EditpropertyModal">Edit Property</h5>
                            <button type="button" className="btn-close btn-close-primary size-10" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <div className="first-section">
                                <h6 className='font-semibold mb-3 '>Basic Details:</h6>
                                <div className="row mb-3">
                                    <div className="col-md-4">
                                        <label htmlFor="sr-no" className="form-label">Sr No (*)</label>
                                        <input type="text" className="form-control" id="sr-no" placeholder="Enter Sr No" />
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <div className="col-md-3">
                                        <label className="form-label">Category (*)</label>
                                        <div>
                                            <div className="form-check form-check-inline">
                                                <input className="form-check-input" type="radio" name="approach" id="approach-direct" value="direct" />
                                                <label className="form-check-label" htmlFor="approach-direct">Residential</label>
                                            </div>
                                            <div className="form-check form-check-inline">
                                                <input className="form-check-input" type="radio" name="approach" id="approach-broker" value="broker" />
                                                <label className="form-check-label" htmlFor="approach-broker">Commercial</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <label htmlFor="status" className="form-label">Sub Category (*)</label>
                                        <select className="form-select" id="status">
                                            <option value="" disabled selected>Select</option>
                                            <option value="1BHK">1BHK</option>
                                            <option value="2BHK">2BHK</option>
                                            <option value="3BHK">3BHK</option>
                                            <option value="4BHK">4BHK</option>
                                            <option value="5BHK">5BHK</option>
                                            <option value="BANGLOW">BANGLOW</option>
                                            <option value="PENTHOUSE">PENTHOUSE</option>
                                            <option value="SHOP">SHOP</option>
                                            <option value="SHOWROOM">SHOWROOM</option>
                                            <option value="PLOT">PLOT</option>
                                            <option value="DUPLEX">DUPLEX</option>
                                            <option value="ROWHOUSE">ROWHOUSE</option>
                                        </select>
                                    </div>
                                    <div className="col-md-4">
                                        <label htmlFor="status" className="form-label">Property For (*)</label>
                                        <select className="form-select" id="status">
                                            <option value="" disabled selected>Select</option>
                                            <option value="HOT">RENT</option>
                                            <option value="PURCHASE/BUY">PURCHASE/BUY</option>

                                        </select>
                                    </div>


                                </div>
                                <div className="row mb-3">
                                    <div className="col-md-3">
                                        <label for="area_size" className="form-label">Area Size (*)</label>
                                        <input type="text" className="form-control" id="area_size" placeholder="" />
                                    </div>
                                    <div className="col-md-3 ">
                                        <label for="price" className="form-label">Price (*)</label>
                                        <input type="text" className="form-control" id="price" placeholder="" />
                                    </div>
                                    <div className="col-md-3 ">
                                        <label for="unit_no" className="form-label">Unit No (*)</label>
                                        <input type="text" className="form-control" id="unit_no" placeholder="" />
                                    </div>
                                    <div className="col-md-3 ">
                                        <label for="society" className="form-label">Society (*)</label>
                                        <input type="text" className="form-control" id="society" placeholder="" />
                                    </div>
                                    <div className="col-md-3 mt-3 ">
                                        <label for="area" className="form-label">Area (*)</label>
                                        <input type="text" className="form-control" id="area" placeholder="" />
                                    </div>
                                    <div className="col-md-3 mt-3 ">
                                        <label for="multiSelect" class="form-label">Amenities</label>
                                        <select className="form-select" id="status">
                                            <option value="" disabled selected>Select</option>
                                            <option value="Initial">Initial</option>
                                            <option value="PURCHASE/BUY">Sold Out</option>
                                            <option value="PURCHASE/BUY">Available</option>
                                            <option value="PURCHASE/BUY">Rent Out</option>
                                            <option value="PURCHASE/BUY">Deal Done</option>
                                            <option value="PURCHASE/BUY">Cancel</option>
                                            <option value="PURCHASE/BUY">Locked In</option>

                                        </select>
                                    </div>
                                    <div className="col-md-3 mt-3 ">
                                        <label for="feature" className="form-label">Features </label>
                                        <input type="text" className="form-control" id="feature" placeholder="" />
                                    </div>
                                    <div className="col-md-3 mt-3 ">
                                        <label for="furniture" className="form-label">Furniture </label>
                                        <input type="text" className="form-control" id="furniture" placeholder="" />
                                    </div>
                                    <div className="col-md-3 mt-3 ">
                                        <label for="furniture" className="form-label">key (*)</label>
                                        <input type="text" className="form-control" id="furniture" placeholder="" />
                                    </div>
                                    <div className="col-md-3 mt-3 ">
                                        <label for="b_year" className="form-label">Build Year </label>
                                        <input type="text" className="form-control" id="b_year" placeholder="" />
                                    </div>
                                    <div className="col-md-3 mt-3 ">
                                        <label for="age" className="form-label">Age </label>
                                        <input type="text" className="form-control" id="age" placeholder="" />
                                    </div>
                                    <div className="col-md-3 mt-3 ">
                                        <label for="brokerage" className="form-label">Brokerage (*) </label>
                                        <input type="text" className="form-control" id="brokerage" placeholder="" />
                                    </div>
                                    <div className="col-md-3 mt-3 ">
                                        <label for="age" className="form-label">Preference </label>
                                        <input type="text" className="form-control" id="age" placeholder="" />
                                    </div>
                                    <div className="col-md-3 mt-3">
                                        <label htmlFor="status" className="form-label">Status (*)</label>
                                        <select className="form-select" id="status">
                                            <option value="" disabled selected>Select</option>
                                            <option value="Initial">Initial</option>
                                            <option value="PURCHASE/BUY">PURCHASE/BUY</option>

                                        </select>
                                    </div>
                                    <div className="col-md-3 mt-3">
                                        <label htmlFor="status" className="form-label">Source (*)</label>
                                        <select className="form-select" id="status">
                                            <option value="" disabled selected>Select</option>
                                            <option value="Initial">Initial</option>
                                            <option value="PURCHASE/BUY">Sold Out</option>
                                            <option value="PURCHASE/BUY">Available</option>
                                            <option value="PURCHASE/BUY">Rent Out</option>
                                            <option value="PURCHASE/BUY">Deal Done</option>
                                            <option value="PURCHASE/BUY">Cancel</option>
                                            <option value="PURCHASE/BUY">Locked In</option>

                                        </select>
                                    </div>
                                </div>


                            </div>

                            {/* Client Details Section */}
                            <div className='mb-3' style={{ borderTop: "2px solid #f0f0f0" }} />
                            <div className="second-section">
                                <h6 className='font-semibold mb-3'>Client Details:</h6>
                                <div className="row mb-3">
                                    <div className="col-md-4">
                                        <label htmlFor="name" className="form-label">Name (*)</label>
                                        <input type="text" className="form-control" id="name" placeholder="Enter client name" />
                                    </div>
                                    <div className="col-md-4">
                                        <label for="mobile" className="form-label">Mobile No (*)</label>
                                        <input type="tel" className="form-control" id="mobilepropertyedit" placeholder="Enter mobile number" />
                                    </div>
                                    <div className="col-md-4">
                                        <label htmlFor="email" className="form-label">Email ID</label>
                                        <input type="email" className="form-control" id="email" placeholder="Enter email" />
                                    </div>

                                </div>

                                {/* Status Section */}
                              
                              
                            </div>

                            {/* Other sections */}
                            <div className='mb-3' style={{ borderTop: "2px solid #f0f0f0" }} />
                            <div className="fourth-section">
                                <h6 className='font-semibold mb-3'>Other:</h6>
                                <div className="row mb-3">
                                    <div className="col-md-6">
                                        <label htmlFor="remarks" className="form-label">Remarks (*)</label>
                                        <textarea className="form-control" id="remarks" rows="3"></textarea>
                                    </div>
                                    <div className="col-md-4 ">
                                        <label htmlFor="native" className="form-label">Keywords</label>
                                        <input type="native" className="form-control" id="native" placeholder="" />
                                    </div>
                                    <div className="col-md-4 mt-3">
                                        <label htmlFor="response" className="form-label">Assign To (*)</label>
                                        <select className="form-select" id="response">
                                            <option value="" disabled selected>Select</option>
                                            <option value="INTERESTED">INTERESTED</option>
                                            <option value="NOT INTERESTED">NOT INTERESTED</option>
                                            <option value="WILL INFORM SOON">WILL INFORM SOON</option>
                                            {/* Add other options here */}
                                        </select>
                                    </div>

                                </div>


                            </div>
                        </div>

                        <div className="modal-footer justify-content-between p-3" style={{ borderTop: "2px solid #f0f0f0" }}>
                            <button
                                type="button"
                                className="btn btn-outline-primary d-flex align-items-center gap-2"
                                style={{ borderRadius: "30px", padding: "0.5rem 1.5rem" }}
                                data-bs-dismiss="modal"
                            >
                                <i className="bi bi-x-circle"></i> Close
                            </button>
                            <button
                                type="button"
                                className="btn btn-gradient d-flex align-items-center text-white gap-2"
                                style={{ borderRadius: "30px", padding: "0.5rem 1.5rem", background: "linear-gradient(90deg, #6a11cb 0%, #313265 100%)", color: "white", border: "none" }}
                            >
                                <i className="bi bi-plus-circle"></i> Add
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EditProperty;
